module.exports = __webpack_public_path__ + "h5/img/2-001.63a0bfcd.png";